import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ja from "javascript-time-ago/locale/ja";
import { dateToLocaleString } from "./dateUtils";

TimeAgo.addLocale(ja);
TimeAgo.addLocale(en);

const timeAgoEn = new TimeAgo("en-US");
const timeAgoJa = new TimeAgo("ja");
const HOURS_23 = 1000 * 60 * 60 * 23;

export const timeAgo = (date, lang) => {
  let output = "";

  try {
    if (isMoreThan1DayOld(date)) {
      output = dateToLocaleString(date, lang);
    } else {
      output = timeAgoFormat(date, lang);
    }
  } catch (err) {
    console.error("Could not format time ago:", date, err);
  }
  return output;
};

const timeAgoFormat = (date, lang) => {
  return lang === "en" ? timeAgoEn.format(date) : timeAgoJa.format(date);
};

const isMoreThan1DayOld = (date) => {
  const now = new Date();
  const timeDiffMs = now - date;
  return timeDiffMs > HOURS_23;
};
